import $ from 'jquery';

$( function() {
	$( '.embed-btn' ).on( 'click keydown', function( e ) {
		if ( e.type === 'keydown' && e.which !== 13 && e.which !== 32 ) {
			return;
		}
		const iFrameWrapper = $( this ).siblings( '.dynamic-embed' );
		const embedCode = iFrameWrapper.attr( 'data-src' );
		const height = $( this ).find( '.embed-img' ).height();
		iFrameWrapper.height( height );
		iFrameWrapper.html( embedCode );
		$( this ).hide();
		$( this ).siblings( '.preview-text' ).hide();
	} );
} );
